import React, { useRef, useEffect, useContext } from 'react';
import { Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import useStyles, { PreambleTitleTypography } from './styles';
import * as utils from './utils';
import PlanningButton from '../components/common/PlanningButton';
import { PlanContext } from '../context/PlanContext';

const SmartVentureInvesting = ({
  title,
  leftColumnContent,
  rightColumnImage,
  buttonText,
  onContinue,
  isMobile = false,
}) => {
  const classes = useStyles();
  const { planningButtonLoading } = useContext(PlanContext);

  const elRef = useRef(null);
  useEffect(() => {
    const scrollHandler = utils.bindAnimationResetScrollHandler(elRef.current);

    return () => {
      document.removeEventListener('scroll', scrollHandler);
    };
  }, [elRef]);

  return (
    <Box className={classes.preamblePageContainer}>
      <PreambleTitleTypography component="h1">{title}</PreambleTitleTypography>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={6}
          display="flex"
          alignItems="center"
          justifyContent="space-around"
        >
          <div
            className={classes.textContent}
            dangerouslySetInnerHTML={{ __html: leftColumnContent }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          display="flex"
          alignItems="center"
          justifyContent="space-around"
        >
          <video
            className={classes.video}
            ref={elRef}
            autoPlay
            playsInline
            muted
            onError={(e) => console.error('Video error:', e)}
          >
            <source src={rightColumnImage} type="video/mp4" />
          </video>
        </Grid>
      </Grid>
      <div className={classes.continueButton}>
        <PlanningButton
          text={buttonText}
          onClick={onContinue}
          isLoading={planningButtonLoading}
          disabled={planningButtonLoading}
          width={isMobile ? '250px' : '350px'}
        />
      </div>
    </Box>
  );
};

SmartVentureInvesting.propTypes = {
  title: PropTypes.string.isRequired,
  leftColumnContent: PropTypes.string.isRequired,
  rightColumnImage: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onContinue: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

export default SmartVentureInvesting;
